import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { RequiredAsterisk } from '@components';

export const RequiredIndicator = () => {
  const { t } = useTranslation('common');
  return (
    <Typography
      sx={{
        mb: 1,
        fontSize: '13px',
        fontWeight: 500,
        lineHeight: 1.2,
        color: 'custom.inputLabel',
      }}
    >
      {t('required')} <RequiredAsterisk />
    </Typography>
  );
};
